(() => {
  if (!document.body.classList.contains('sp-accessible')) return;
  const header = document.querySelector('.section-header') || document.querySelector('sticky-header');
  if (header) {
    let previousOffset = 0;
    const updateHeaderOffset = () => {
      const offset = Math.ceil(header.getBoundingClientRect().height) + 24;
      if (offset !== previousOffset) {
        document.body.style.setProperty('--sp-access-header-offset', `${offset}px`);
        previousOffset = offset;
      }
    };
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(updateHeaderOffset).observe(header);
  }
  const main = document.getElementById('MainContent');
  const labelsNode = document.getElementById('sp-access-labels');
  let labels = {};
  try { labels = JSON.parse(labelsNode?.textContent || '{}'); } catch (_) { return; }
  const routes = new Map([
    ['/pages/spider-people-in-training', ['SPiT I', 'Spider People in Training', labels.course]],
    ['/pages/spider-people-network', ['Spider People Network', labels.network]],
    ['/pages/spider-people-kids-club', ['Spider People Kids Club', labels.kids]],
    ['/pages/spn-approved-businesses', ['SPN Approved Businesses', labels.businesses]]
  ]);
  document.querySelectorAll('header a, .menu-drawer a').forEach((link) => {
    const path = new URL(link.href, location.href).pathname.replace(/\/$/, '');
    const rule = routes.get(path);
    if (!rule || !rule.slice(0, -1).includes(link.textContent.trim()) || !rule.at(-1)) return;
    const hint = document.createElement('small');
    hint.className = 'sp-access-nav-hint';
    hint.textContent = rule.at(-1);
    link.append(hint);
  });
  document.querySelectorAll('[data-sp-course-toc]').forEach((courseToc) => {
    const updateCourseToc = () => {
      let visible = 0;
      courseToc.querySelectorAll('a[href^="#sp-access-course-"]').forEach((link) => {
        const target = document.getElementById(link.hash.slice(1));
        const available = Boolean(target?.getClientRects().length) && !target?.closest('[hidden]');
        link.closest('li').hidden = !available;
        if (available) visible += 1;
      });
      courseToc.hidden = visible === 0;
    };
    courseToc.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#sp-access-course-"]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target?.getClientRects().length || target.closest('[hidden]')) return;
      event.preventDefault();
      courseToc.open = false;
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
      const heading = target.querySelector('h2') || target;
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    });
    const observer = new MutationObserver(updateCourseToc);
    main?.querySelectorAll('[data-spit-view], [data-spit-extra-view]').forEach((view) => {
      observer.observe(view, { attributes: true, attributeFilter: ['hidden'] });
    });
    requestAnimationFrame(updateCourseToc);
  });
  const toc = document.querySelector('[data-sp-toc]');
  const list = document.querySelector('[data-sp-toc-list]');
  if (toc && list && main) {
    const headings = [...main.querySelectorAll('.spx h2, .spb h2, .spba h2, .spbc h2, .spbl h2')].filter((heading) => heading.getClientRects().length && !heading.closest('form, .shopify-app-block, [hidden], [aria-hidden="true"]'));
    if (headings.length > 1) {
      headings.forEach((heading, index) => {
        const target = heading.closest('.spx-section-head, .spb-section-head, .spba-section-head, .spbc-section-head, .spbl-section-head') || heading;
        if (!target.id) {
          let id = `sp-access-section-${index + 1}`;
          while (document.getElementById(id)) id += '-section';
          target.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${target.id}`;
        link.textContent = heading.dataset.spTocLabel || heading.textContent.trim();
        link.addEventListener('click', () => {
          toc.open = false;
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          requestAnimationFrame(() => heading.focus({ preventScroll: true }));
        });
        item.append(link);list.append(item);
      });
      toc.hidden = false;
    }
  }
  if (location.pathname.endsWith('/products/latrodectus-hesperus-western-black-widow')) {
    document.querySelectorAll('.product__description .ytp-chrome-top, .product__description .ytp-chrome-bottom, .product__description .ytp-gradient-top, .product__description .ytp-gradient-bottom').forEach((artifact) => { if (!artifact.closest('iframe')) artifact.hidden = true; });
  }
})();
